/**
 * Different types of Switch designs.
 * @public
 */
enum SwitchDesign {
	/**
	 * Defines the Switch as Textual
	 * @public
	 */
	Textual = "Textual",

	/**
	 * Defines the Switch as Graphical
	 * @public
	 */
	Graphical = "Graphical",
}

export default SwitchDesign;
